import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import moment, { Moment } from "moment";
import { useEffect, useState } from "react";
import { useUsuario } from "../../../../providers/usuarioProvider";
import MoedaInput from "../../../util/ui/inputs/moedaInput";
import InteiroInput from "../../../util/ui/inputs/inteiroInput";
import { IconBookmark, IconPlus } from "@tabler/icons-react";
import ExercicioDireito from "../../../../models/exercicioDireito";
import { map } from "lodash";
import Direito from "../../../../models/direito";
import Functions from "../../../../callable/functions";
import {
  addDoc,
  deleteDoc,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import ExercicioDireitoDb from "../../../../db/exercicioDireitoDb";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import TabelaExercicios from "../../../util/tabelas/tabelaExercicios";
export const dataMinimaB3 = moment("2019-11-01");

export default function AbaSubscricoes() {
  const { visualizado } = useUsuario();
  const [exercicios, setExercicios] = useState<ExercicioDireito[]>();
  const [openNovoExercicio, setOpenNovoExercicio] = useState(false);

  useEffect(() => {
    if (!!visualizado)
      return onSnapshot(
        query(
          new ExercicioDireitoDb().collection({
            usuarioId: visualizado,
            exercicioDireitoId: "",
          }),
          orderBy("dataExercicio", "desc")
        ),
        (query) => setExercicios(map(query.docs, (doc) => doc.data()))
      );
  }, [visualizado]);

  const apagarExercicio = async (exercicio: ExercicioDireito) => {
    if (!!visualizado)
      return await deleteDoc(
        new ExercicioDireitoDb().doc({
          usuarioId: visualizado,
          exercicioDireitoId: exercicio.id,
        })
      );
  };

  return (
    <Box display={"flex"} flexDirection="column">
      <Box
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        pb={2}
        gap={2}
      >
        <Typography variant="eyebrow" color="text.secondary">
          Exercícios de subscrição
        </Typography>
        <Button
          variant="contained"
          color="primary"
          startIcon={<IconPlus />}
          onClick={() => setOpenNovoExercicio(true)}
        >
          Exercício
        </Button>
      </Box>
      <TabelaExercicios exercicios={exercicios} onDelete={apagarExercicio} />
      <NovoExercicio
        open={openNovoExercicio}
        onClose={() => setOpenNovoExercicio(false)}
      />
    </Box>
  );
}

type Props = {
  onClose: () => void;
  open: boolean;
};

function NovoExercicio({ onClose, open }: Props) {
  const { visualizado } = useUsuario();
  const [codigoAtivo, setCodigoAtivo] = useState<string | undefined>(undefined);
  const [exercicio, setExercicio] = useState<Moment | undefined>(undefined);
  const [quantidade, setQuantidade] = useState<number | undefined>(undefined);
  const [direitoExercido, setDireitoExercido] = useState<Direito | undefined>(
    undefined
  );

  useEffect(() => {
    let subscribed = true;
    if (!!codigoAtivo && !!exercicio && exercicio.isValid()) {
      new Functions()
        .direitoAutoComplete({ codigoAtivo, data: exercicio.format() })

        .then((res) => {
          if (subscribed)
            setDireitoExercido(
              res.data?.direito ? Direito.fromJson(res.data.direito) : undefined
            );
        });
    }
    return () => {
      subscribed = false;
    };
  }, [codigoAtivo, exercicio]);

  const criarExercicio = async () => {
    if (
      !!visualizado &&
      !!codigoAtivo &&
      !!exercicio &&
      !!quantidade &&
      !!direitoExercido
    )
      return await addDoc(
        new ExercicioDireitoDb().collection({
          usuarioId: visualizado,
          exercicioDireitoId: "",
        }),
        new ExercicioDireito({
          id: "",
          isinDireito: direitoExercido.isin,
          codigoAtivo: codigoAtivo,
          dataExercicio: exercicio,
          quantidade: quantidade,
          precoUnitario: direitoExercido.precoUnitario,
          codigoObjeto: direitoExercido.codigoObjeto,
        })
      ).then(() => {
        setCodigoAtivo(undefined);
        setExercicio(undefined);
        setQuantidade(undefined);
        setDireitoExercido(undefined);
      });
  };

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle color="text.primary">
        <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
          <Box
            display="flex"
            sx={(theme) => ({ color: theme.palette.accentInk })}
          >
            <IconBookmark size={16} />
          </Box>
          <Typography variant="h3">Adicionar novo exercício</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box display={"flex"} flexDirection="column">
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            Ao preencher o Código do Direito e a data de Exercício,
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic" }}
          >
            o Preço Unitário é automaticamente preenchido.
          </Typography>
          <Box paddingY={2} />
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box paddingRight={1}>
              <Typography variant="labelMono" color="text.secondary">
                Código do Direito:
              </Typography>
            </Box>
            <TextField
              id="standard-direito"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={(theme) => ({
                width: "18ch",
                // Ticker é código: mono tabular, igual à coluna de tabela.
                "& .MuiInputBase-input": {
                  fontFamily: theme.typography.dataMono.fontFamily,
                  fontVariantNumeric: "tabular-nums",
                  letterSpacing: "0.04em",
                },
              })}
              variant="outlined"
              value={codigoAtivo ?? ""}
              onChange={(e) => setCodigoAtivo(e.target.value.toUpperCase())}
              placeholder="CVCB1"
            />
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            paddingTop={1}
          >
            <Box paddingRight={1}>
              <Typography variant="labelMono" color="text.secondary">
                Exercício
              </Typography>
            </Box>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={(theme) => ({
                  width: "18ch",
                  // Data é número: mono tabular.
                  "& .MuiInputBase-input": {
                    fontFamily: theme.typography.dataMono.fontFamily,
                    fontVariantNumeric: "tabular-nums",
                  },
                })}
                slotProps={{ textField: { size: "small" } }}
                value={exercicio ?? null}
                minDate={dataMinimaB3}
                onChange={(e) => {
                  if (e?.isValid()) setExercicio(e.startOf("day"));
                }}
              />
            </LocalizationProvider>
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            paddingTop={1}
          >
            <Box paddingRight={1}>
              <Typography variant="labelMono" color="text.secondary">
                Quantidade
              </Typography>
            </Box>
            <TextField
              id="standard-quantidade"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: "18ch" }}
              variant="outlined"
              value={quantidade ?? ""}
              onChange={(e) =>
                // @ts-ignore
                setQuantidade(e.target.floatValue)
              }
              InputProps={{
                inputComponent: InteiroInput as any,
              }}
            />
          </Box>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            paddingTop={1}
          >
            <Box paddingRight={1}>
              <Typography variant="labelMono" color="text.secondary">
                Preço Unitário
              </Typography>
            </Box>
            <TextField
              id="standard-precoUnitario"
              size="small"
              InputLabelProps={{
                shrink: true,
              }}
              sx={{ width: "18ch" }}
              variant="outlined"
              disabled
              value={direitoExercido?.precoUnitario ?? ""}
              InputProps={{
                inputComponent: MoedaInput as any,
              }}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose()} color="inherit">
          Cancelar
        </Button>
        <Button
          onClick={criarExercicio}
          disabled={
            !visualizado ||
            !codigoAtivo ||
            !exercicio ||
            !quantidade ||
            !direitoExercido
          }
          variant="contained"
          color="primary"
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
